import { render, staticRenderFns } from "./ImportExportForm.vue?vue&type=template&id=50133960&scoped=true&"
import script from "./ImportExportForm.vue?vue&type=script&lang=js&"
export * from "./ImportExportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50133960",
  null
  
)

export default component.exports